import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=82ec0d30&scoped=true"
import script from "./PopUp.ts?vue&type=script&lang=ts&external"
export * from "./PopUp.ts?vue&type=script&lang=ts&external"
import style0 from "./PopUp.scss?vue&type=style&index=0&id=82ec0d30&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ec0d30",
  null
  
)

export default component.exports